<div id="el_EnlargeContainer" class="enlarge">
    <!--原始小图区域-->
    <div id="el_SmallContainer" class="small">
        <img id="el_SmallImage" />
        <div id="el_maskEnarge" class="mask"></div>
    </div>
    <!--预览大图区域-->
    <div id="el_PreviewContainer" class="preview">
        <img id="el_PreviewImage" />
    </div>
</div>